interface V3IconCloseProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    strokeWidth?: string,
}

export const V3IconClose = ({ stroke = "#ABB0BA", strokeWidth = "1.5", ...rest }: V3IconCloseProps) => <svg width="24" height="24" {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m5 5 14 14M19 5 5 19" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
</svg>